import { render, staticRenderFns } from "./ProductGalleryCarousel.vue?vue&type=template&id=07b17c59&"
import script from "./ProductGalleryCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports